import { render } from "./VocExportDrawer.vue?vue&type=template&id=a4127b04&scoped=true"
import script from "./VocExportDrawer.vue?vue&type=script&lang=js"
export * from "./VocExportDrawer.vue?vue&type=script&lang=js"

import "./VocExportDrawer.vue?vue&type=style&index=0&id=a4127b04&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4127b04"]])

export default __exports__